import { memo } from 'react';
import { Close } from '@mui/icons-material';
import { IconButton, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Banner = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  padding: '8px 12px',
  marginBottom: '8px',
  borderRadius: '8px',
  backgroundColor: theme.palette.secondary.light,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

type NotificationsFilterBannerProps = {
  onClear: () => void;
};

export const NotificationsFilterBanner = memo(({ onClear }: NotificationsFilterBannerProps) => {
  const { t } = useTranslation();

  return (
    <Banner>
      <Typography variant="body2">{t('user.notifications.filter.active')}</Typography>
      <IconButton size="small" onClick={onClear} aria-label={t('user.notifications.filter.clear')}>
        <Close fontSize="small" />
      </IconButton>
    </Banner>
  );
});
